module.exports = __webpack_public_path__ + "img/cardOneImg.3860acc9.png";